import script from "./OurStars.vue?vue&type=script&setup=true&lang=js"
export * from "./OurStars.vue?vue&type=script&setup=true&lang=js"

import "./OurStars.vue?vue&type=style&index=0&id=57192e8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57192e8c"]])

export default __exports__